import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[validDocument1]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: ValidDocument1ValidatorDirective,
        multi: true
    }]
})
export class ValidDocument1ValidatorDirective implements Validator {
    @Input() validDocument1: string;

    validate(control: AbstractControl): {[key: string]: any} {
        return this.validDocument1
            ? (this.validDocument1 === 'cpf'
                ? cpfValidationFn(control)
                : cnpjValidationFn(control)
            ) : null;
    }
}

export function cpfValidationFn(control, blockEqualNumberSequence = true) {
    let value = control.value;
    blockEqualNumberSequence = blockEqualNumberSequence || true;
    if (!value) {
        return null;
    }
    value = value.replace(/\D/g, '');

    const allNumbersAreEqual = value === '00000000000' ||
        value === '11111111111' || value === '22222222222' || value === '33333333333' ||
        value === '44444444444' || value === '55555555555' || value === '66666666666' ||
        value === '77777777777' || value === '88888888888' || value === '99999999999';
    if (allNumbersAreEqual && blockEqualNumberSequence) {
        return {
            cpf: true
        };
    }
    let soma = 0;
    let resto;
    for (let i = 1; i <= 9; i++) {
        soma += parseInt(value.substring(i - 1, i), 0) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
        resto = 0;
    }
    if (resto !== parseInt(value.substring(9, 10), 0)) {
        return {
            cpf: true
        };
    }
    soma = 0;
    for (let i = 1; i <= 10; i++) {
        soma += parseInt(value.substring(i - 1, i), 0) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if ((resto === 10) || (resto === 11)) {
        resto = 0;
    }
    if (resto !== parseInt(value.substring(10, 11), 0)) {
        return {
            cpf: true
        };
    }
    return null;
}

export function cnpjValidationFn(control, blockEqualNumberSequence = true) {
    let value = control.value;
    blockEqualNumberSequence = blockEqualNumberSequence || true;
    if (!value) {
        return null;
    }
    value = value.replace(/\D/g, '');
    if (value.length !== 14) {
        return {
            cnpj: true
        };
    }
    const allNumbersAreEqual = value === '00000000000000' ||
        value === '11111111111111' || value === '22222222222222' || value === '33333333333333' ||
        value === '44444444444444' || value === '55555555555555' || value === '66666666666666' ||
        value === '77777777777777' || value === '88888888888888' || value === '99999999999999';
    if (allNumbersAreEqual && blockEqualNumberSequence) {
        return {
            cnpj: true
        };
    }
    let tamanho = value.length - 2;
    let numeros = value.substring(0, tamanho);
    let digitos = value.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== Number.parseInt(digitos.charAt(0))) {
        return {
            cnpj: true
        };
    }
    tamanho = tamanho + 1;
    numeros = value.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== Number.parseInt(digitos.charAt(1))) {
        return {
            cnpj: true
        };
    }
    return null;
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/validators/valid-document1.directive.ts